const Radio = ({ id, name, checked, value, disabled, onChange = () => {}, className = '' }) => {
    const calcStyle = () => {
        if (disabled) {
            if (checked) {
                return 'cursor-not-allowed border-4 bg-sf-white border-sf-primary-200';
            }

            return 'cursor-not-allowed border-2 border-sf-gray-300 bg-sf-gray-100';
        } else {
            if (checked) {
                return 'cursor-pointer bg-sf-white border-4 border-sf-primary-500 hover:border-sf-primary-700';
            }

            return 'cursor-pointer border-2 bg-sf-white border-sf-gray-300 hover:border-sf-gray-400';
        }
    };

    return (
        <input
            className={`flex mt-0 justify-center items-center h-4 w-4 appearance-none focus:outline-none rounded-full ${calcStyle()} ${className}`}
            type="radio"
            disabled={disabled}
            id={id}
            name={name}
            checked={checked}
            onChange={() => onChange(value)}
        />
    );
};

export default Radio;
